import { useQuery } from "@apollo/client";
import { GET_USER } from "graphql/user";

/**
 * Whether the company's merchant account is set up with the acquirer it pays
 * through. Until it is, nothing that asks a customer to pay is offered.
 */
const useCanTakePayments = (): boolean => {
  const { data } = useQuery(GET_USER, { fetchPolicy: "cache-first" });
  return Boolean(data?.user?.company?.canTakePayments);
};

export default useCanTakePayments;
